<table class="striped table">
  <thead>
    <tr>
      <th>{{ 'common.name' | translate }}</th>
      <th>{{ 'common.description' | translate }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let section of sections">
      <td>{{ section.name }}</td>
      <td>{{ section.description }}</td>
      <td (click)="selectSection(section)">{{ 'sections.detail' | translate }}</td>
    </tr>
  </tbody>
</table>
